import { call, put, takeLatest, select } from "redux-saga/effects";
import * as types from "../actions/actionTypes";
import {
  InitAction,
  ProjectAction,
  NotificationAction,
  UserAction
} from "../actions";
import * as projectApi from "../api/project";
import { toastr } from "react-redux-toastr";
import { SetMessage } from "../assets/errorMessages";
import { CURRENCY, PROJECT_ID } from "../constants/storageKeys";
import { goBack } from "connected-react-router";
import { removeProjectRelatedLocalStorage } from "../assets/projectLocalStorage";

export function* watcherProject() {
  yield takeLatest(types.PROJECT_LIST_REQUEST, worker);
  yield takeLatest(types.PROJECT_STORE_REQUEST, store);
  yield takeLatest(types.PROJECT_DELETE_REQUEST, _delete);
  yield takeLatest(types.PROJECT_UPDATE_REQUEST, edit);
  yield takeLatest(types.PROJECT_ACCEPT_REQUEST, accept);
  yield takeLatest(types.PROJECT_REJECT_REQUEST, reject);
  yield takeLatest(types.PROJECT_ARCHIVE_REQUEST, archive);
  yield takeLatest(types.PROJECT_TYPES_REQUEST, getTypes);
  yield takeLatest(types.PROJECT_ANSWER_INVITATION_REQUEST, answerInvitation);
}

function fetchList(filter) {
  return projectApi.list(filter);
}

function* worker(action) {
  try {
    const response = yield call(fetchList, action.filter);
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
    yield put(UserAction.getInfoSuccess(response.data.user));
    yield put(ProjectAction.getSuccess(response.data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ProjectAction.getFailure(message));
  }
}

function fetchStore(data) {
  return projectApi.store(data);
}

function* store(action) {
  try {
    const response = yield call(fetchStore, action.data);
    const data = response.data;
    yield put(InitAction.getSuccess({ updatePremium: data.premium }));
    data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ProjectAction.storeSuccess(data.data));
    yield put(goBack());
  } catch (error) {
    SetMessage(error, true);
    yield put(ProjectAction.storeFailure());
  }
}

function deleteProject(id) {
  return projectApi._delete(id);
}

function* _delete(action) {
  try {
    const response = yield call(deleteProject, action.id);
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    if (parseInt(action.id) === parseInt(localStorage.getItem(PROJECT_ID))) {
      localStorage.removeItem(PROJECT_ID);
      window.location.reload();
    } else {
      yield put(ProjectAction.deleteSuccess(action.id));
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(ProjectAction.deleteFailure());
  }
}

function editProject(data, id) {
  return projectApi.edit(data, id);
}

function* edit(action) {
  try {
    const response = yield call(editProject, action.data, action.id);
    const data = response.data;
    data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    const projectData = data.data;
    if (
      parseInt(projectData.id) === parseInt(localStorage.getItem(PROJECT_ID))
    ) {
      localStorage.setItem(CURRENCY, projectData.currency.symbol_fa);
      yield put(InitAction.getSuccess({ projectData: projectData }));
      yield put(goBack());
    } else {
      yield put(goBack());
    }
    yield put(ProjectAction.updateSuccess(projectData));
  } catch (error) {
    SetMessage(error, true);
    yield put(ProjectAction.updateFailure(error));
  }
}
function acceptProject(projectId) {
  return projectApi.accept(projectId);
}
function* accept(action) {
  try {
    const response = yield call(acceptProject, action.projectId);
    const project = response.data.project;
    // if (
    //   project.project.premium_state === PREMIUM ||
    //   project.project.premium_state === NEAR_ENDING_PREMIUM
    // ) {
    //   localStorage.setItem(
    //     "project_info",
    //     JSON.stringify({ ...project.project, is_owner: project.is_owner })
    //   );
    //   localStorage.setItem("project_id", response.data.project.project.id);
    //   window.location.href = "/";
    // } else {
    //   yield put(ProjectAction.acceptSuccess(response.data.project));
    //   yield put(InvitationAction.acceptSuccess(action.id, response.data.data));
    //   yield put(
    //     NotificationAction.setNotificationCount(
    //       response.data.count,
    //       response.data.feedback_count
    //     )
    //   );
    // }
  } catch (error) {
    SetMessage(error, true);
    yield put(ProjectAction.acceptFailure());
  }
}
function rejectProject(projectId) {
  return projectApi.reject(projectId);
}
function* reject(action) {
  try {
    const response = yield call(rejectProject, action.projectId);
    yield put(ProjectAction.rejectSuccess(action.id));
    yield put(
      NotificationAction.setNotificationCount(
        response.data.count,
        response.data.feedback_count
      )
    );
  } catch (error) {
    SetMessage(error, true);
    yield put(ProjectAction.rejectFailure());
  }
}

function archiveProject(id, data) {
  return projectApi.archive(id, data);
}

function* archive(action) {
  try {
    const response = yield call(archiveProject, action.id, action.data);
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(ProjectAction.archiveSuccess(action.id, action.data));
    if (action.id === parseInt(localStorage.getItem(PROJECT_ID))) {
      removeProjectRelatedLocalStorage();
      window.location.reload();
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(ProjectAction.archiveFailure());
  }
}

function* getTypes() {
  try {
    const response = yield call(fetchTypes);
    let data = response.data.data;
    yield put(ProjectAction.getTypesSuccess(data));
  } catch (error) {
    const message = SetMessage(error);
    yield put(ProjectAction.getTypesFailure(message));
  }
}

function fetchTypes() {
  return projectApi.getProjectType();
}

function answerInviteToProject(projectId, ansIsAccept) {
  if (ansIsAccept) {
    return projectApi.accept(projectId);
  } else {
    return projectApi.reject(projectId);
  }
}

const getNotification = store => store.Notification.list;

function* answerInvitation(action) {
  try {
    const response = yield call(
      answerInviteToProject,
      action.projectId,
      action.ansIsAccept
    );
    response.data.message.forEach(message => {
      toastr.success(" ", message.toString());
    });
    yield put(NotificationAction.setNotificationCount(response.data.unread_count));
    const notification = yield select(getNotification);
    const pendingProjectsList = notification.pending_projects;
    const newPendingProjectsList = pendingProjectsList.filter(
        pr => pr.id !== action.projectId
    );
    let newNotificationList = {
      ...notification,
      pending_projects: newPendingProjectsList
    };
    yield put(NotificationAction.getListSuccess(newNotificationList));
    yield put(
      ProjectAction.answerInvitationSuccess(
        action.projectId,
        action.ansIsAccept,
        response.data.data
      )
    );
    yield put(ProjectAction.setConfirmInfo({}));
  } catch (error) {
    SetMessage(error, true);
    yield put(ProjectAction.answerInvitationFailure());
  }
}
